<template>
  <el-dialog
    class="large-dialog"
    title="新增任务"
    :visible="showAddTaskDialog"
    width="1200px"
    @close="closeAddTaskDialog"
  >
    <!-- (1) 任务类型 + 任务名称 + 精准搜索名称 -->
    <el-form :model="localTask" label-width="100px" :rules="rules">
      <!-- 任务类型: 1=常规,2=紧急 -->
      <el-form-item label="任务类型" prop="taskType">
        <el-radio-group v-model="localTask.taskType">
          <el-radio :label="1">常规</el-radio>
          <el-radio :label="2">紧急</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="任务名称" prop="taskName">
        <el-input v-model="localTask.taskName" />
      </el-form-item>
      <el-form-item label="精准搜索" prop="shortDramaAdName">
        <el-input v-model="localTask.shortDramaAdName" />
      </el-form-item>
      <el-form-item label="bid" prop="bid">
        <el-input v-model="localTask.bid" maxlength="50" />
      </el-form-item>
      <el-form-item label="自定义标签" prop="tags">
        <!-- 输入框，回车后添加标签 -->
        <el-input
          v-model="tagInput"
          placeholder="回车添加标签"
          @keyup.enter.native="handleAddTag"
        />
        <!-- 已添加的标签列表 -->
        <div style="margin-top: 10px">
          <el-tag
            v-for="(tag, index) in localTask.tags"
            :key="index"
            closable
            style="margin-right: 5px"
            @close="handleRemoveTag(index)"
          >
            {{ tag }}
          </el-tag>
        </div>
      </el-form-item>
    </el-form>

    <el-divider />

    <!-- (2) 媒体区域：多分类展示 -->
    <div class="media-section">
      <div class="section-title">媒体：</div>

      <!-- 媒体切换按钮 -->
      <div>
        <el-button type="primary" size="mini" @click="toggleMediaMode">
          {{ localTask.useHotMedia ? '切换到全部媒体' : '切换到热门媒体' }}
        </el-button>
      </div>

      <!-- 如果使用热门媒体：多选 checkbox -->
      <div v-if="localTask.useHotMedia" style="margin-top: 10px">
        <!-- 统一使用 selectedMediaIds 做 v-model -->
        <el-checkbox-group v-model="localTask.selectedMediaIds">
          <el-checkbox
            v-for="item in hotMediaList"
            :key="item.media_id"
            :label="item.media_id"
            style="width: 10vw; margin: 0.5vw 0vw"
          >
            <img
              v-if="item.media_logo"
              :src="item.media_logo"
              alt="icon"
              style="width: 15px; height: 15px; margin-right: 5px"
            >
            {{ item.media_name }}
          </el-checkbox>
        </el-checkbox-group>
      </div>

      <!-- 如果使用全部媒体：多选 checkbox -->
      <div v-else style="margin: 5px 20px">
        <div
          v-for="catItem in allMediaList"
          :key="catItem.type_id"
          class="media-category"
        >
          <div class="category-name" style="color: #000; font-weight: bold">
            {{ catItem.type_name }}
          </div>
          <!-- 同样用 selectedMediaIds -->
          <el-checkbox-group v-model="localTask.selectedMediaIds">
            <el-checkbox
              v-for="mediaObj in catItem.list"
              :key="mediaObj.media_id"
              :label="mediaObj.media_id"
              style="width: 7vw; margin: 0.5vw 0vw"
            >
              <img
                v-if="mediaObj.media_logo"
                :src="mediaObj.media_logo"
                alt="icon"
                style="width: 15px; height: 15px; margin-right: 5px"
              >
              {{ mediaObj.media_name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>

    <el-divider />

    <!-- (3) 更多筛选区域 -->
    <div class="more-filter">
      <div class="section-title">更多筛选：</div>

      <!-- 手机平台 (单选) -->
      <div class="filter-group">
        <span class="filter-label">手机平台：</span>
        <el-select
          v-model="localTask.mobilePlatform"
          placeholder="请选择"
          clearable
          style="width: 200px"
        >
          <el-option
            v-for="platform in mobilePlatforms"
            :key="platform"
            :label="platform"
            :value="platform"
          />
        </el-select>
      </div>

      <!-- 广告形式 (多选) -->
      <div class="filter-group">
        <span class="filter-label">广告形式：</span>
        <el-select
          v-model="localTask.adFormat"
          placeholder="请选择"
          multiple
          clearable
          style="width: 300px"
        >
          <el-option
            v-for="format in adFormats"
            :key="format.value"
            :label="format.label"
            :value="format.value"
          />
        </el-select>
      </div>

      <!-- 素材类型 & 图片类型 -->
      <div class="filter-group">
        <span class="filter-label">素材类型：</span>
        <el-select
          v-model="localTask.materialType"
          placeholder="请选择"
          clearable
          style="width: 120px"
        >
          <el-option
            v-for="type in materialTypes"
            :key="type.value"
            :label="type.label"
            :value="type.value"
          />
        </el-select>

        <!-- 当素材类型=图片，则显示图片类型 -->
        <div v-if="localTask.materialType === 1" style="margin-left: 15px">
          <span class="filter-label">图片类型：</span>
          <el-select
            v-model="localTask.imageType"
            placeholder="请选择"
            clearable
            style="width: 120px"
          >
            <el-option
              v-for="image in imageTypes"
              :key="image.value"
              :label="image.label"
              :value="image.value"
            />
          </el-select>
        </div>
      </div>

      <!-- 素材属性：布局、清晰度、视频时长 + 时间区间 -->
      <div
        class="filter-group"
        style="flex-direction: column; align-items: flex-start"
      >
        <span class="filter-label">素材属性：</span>
        <div class="inner-box">
          <!-- 布局 -->
          <div class="mini-filter-line">
            布局：
            <el-checkbox-group
              v-model="localTask.layout"
              style="margin-top: 10px"
            >
              <el-checkbox
                v-for="item in layoutOptions"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </div>

          <!-- 清晰度 -->
          <div class="mini-filter-line">
            清晰度：
            <el-checkbox-group
              v-model="localTask.resolution"
              style="margin-top: 10px"
            >
              <el-checkbox
                v-for="item in resolutionOptions"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </div>

          <!-- 视频时长 -->
          <div class="mini-filter-line">
            视频时长：
            <el-checkbox-group
              v-model="localTask.duration"
              style="margin-top: 10px"
            >
              <el-checkbox label="0-3分钟" />
              <el-checkbox label="3-5分钟" />
              <el-checkbox label="5-10分钟" />
              <el-checkbox label="10分钟以上" />
            </el-checkbox-group>
          </div>

          <!-- 自定义时长区间 -->
          <div
            class="mini-filter-line"
            style="display: flex; align-items: center; gap: 5px"
          >
            <el-input-number
              v-model="localTask.durationFrom"
              :min="0"
              placeholder="起始时长"
              @change="handleDurationFromChange"
            />
            <span>分钟 -</span>
            <el-input-number
              v-model="localTask.durationTo"
              :min="0"
              placeholder="结束时长"
              @change="handleDurationToChange"
            />
            <span>分钟</span>
          </div>
        </div>
      </div>

      <!-- 产品类型 (多选) -->
      <div class="filter-group">
        <span class="filter-label">产品类型：</span>
        <el-select
          v-model="localTask.productAttribute"
          placeholder="请选择"
          multiple
          clearable
          style="width: 300px"
        >
          <el-option
            v-for="prod in productAttributes"
            :key="prod.value"
            :label="prod.label"
            :value="prod.value"
          />
        </el-select>
      </div>
    </div>

    <el-divider />

    <!-- (4) 排序方式 (单选按钮组) -->
    <div class="sort-section">
      <div class="section-title">排序方式：</div>
      <el-radio-group v-model="localTask.sortBy" size="medium">
        <el-radio-button
          v-for="option in sortByOptions"
          :key="option.value"
          :label="option.value"
        >
          {{ option.label }}
        </el-radio-button>
      </el-radio-group>
    </div>

    <el-divider />

    <!-- (5) 高级筛选 (时间范围) -->
    <div class="advance-filter">
      <div class="section-title">高级筛选：</div>
      <!-- 单选按钮组 -->
      <el-radio-group
        v-model="localTask.timePeriod"
        style="margin-bottom: 10px"
        @change="handleTimePeriodChange"
      >
        <el-radio-button key="today" :label="'today'">今天</el-radio-button>
        <el-radio-button
          key="yesterday"
          :label="'yesterday'"
        >昨天</el-radio-button>
        <el-radio-button key="7days" :label="'7days'">7天</el-radio-button>
        <el-radio-button key="30days" :label="'30days'">30天</el-radio-button>
        <el-radio-button key="all" :label="'all'">全部日期</el-radio-button>
      </el-radio-group>

      <!-- 日期范围选择 -->
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        clearable
        style="margin-left: 20px"
        @change="handleDateRangeChange"
      />
    </div>

    <el-divider />

    <!-- (6) 爬取页数 -->
    <el-form
      ref="addTaskForm"
      :model="localTask"
      label-width="100px"
      :rules="rules"
    >
      <el-form-item label="爬取页数" prop="pagesToFetch">
        <el-input-number
          v-model="localTask.pagesToFetch"
          :min="1"
          placeholder="请输入爬取页数"
          style="margin-bottom: 8px"
        />
      </el-form-item>
    </el-form>

    <!-- (7) 底部按钮 -->
    <div class="dialog-footer">
      <el-button class="btn-cancel" @click="closeAddTaskDialog">取消</el-button>
      <el-button type="primary" class="btn-confirm" @click="handleSubmit">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { createAdxTask } from '@/api/miniAd'

export default {
  name: 'AddTaskDialog',
  components: {
    // 如果有其他子组件，可以在这里注册
  },
  data() {
    return {
      localTask: {
        // 任务类型(1=常规,2=紧急)
        taskType: 1,

        // 任务名称 & 精准搜索名称
        taskName: '',
        shortDramaAdName: '',

        bid: '',

        // 媒体选择相关(全部都改为多选)
        useHotMedia: true, // 切换“热门媒体” / “全部媒体”
        selectedMediaIds: [], // ★ 选中的所有媒体ID（热门+全部公用）

        // 更多筛选
        mobilePlatform: '',
        adFormat: [],
        materialType: null,
        imageType: null,
        productAttribute: [],

        // 素材属性
        layout: [],
        resolution: [],
        duration: [],
        durationFrom: null,
        durationTo: null,

        // 排序方式
        sortBy: null,

        // 时间范围
        timePeriod: null, // 单选按钮的值: 'today', 'yesterday', '7days', '30days', 'all'
        start_date: '', // 独立的开始日期
        end_date: '', // 独立的结束日期
        tags: [],

        // 爬取页数
        pagesToFetch: 1
      },
      tagInput: '',
      dateRange: [], // 用于绑定日期范围选择器
      mobilePlatforms: ['iOS', 'Android'],
      hotMediaList: [], // 热门媒体列表
      allMediaList: [], // 全部媒体列表

      rules: {
        // 添加验证规则
        taskType: [
          { required: true, message: '请选择任务类型', trigger: 'change' }
        ],
        taskName: [
          { required: true, message: '请输入任务名称', trigger: 'blur' }
        ],
        shortDramaAdName: [
          { required: true, message: '请输入精准搜索名称', trigger: 'blur' }
        ],
        bid: [
          { required: true, message: '请输入 Bid', trigger: 'blur' },
          { max: 50, message: 'Bid 最大长度为 50', trigger: 'blur' }
        ],
        tags: [
          { required: true, message: '至少输入一个标签并回车', trigger: 'blur' }
        ],
        pagesToFetch: [
          { required: true, message: '请输入爬取页数', trigger: 'change' },
          {
            type: 'number',
            min: 1,
            message: '爬取页数至少为1',
            trigger: 'change'
          }
        ]
      }
    }
  },
  computed: {
    ...mapState('dialog', ['showAddTaskDialog', 'mediaList']),
    ...mapGetters('dialog', [
      'adFormats',
      'materialTypes',
      'layoutOptions',
      'resolutionOptions',
      'productAttributes',
      'imageTypes',
      'sortByOptions'
    ]),
    hotMediaLists() {
      return this.mediaList.hot_media
    },
    allMediaLists() {
      return this.mediaList.media_list
    }
  },
  methods: {
    ...mapActions('dialog', [
      'closeAddTaskDialog',
      'openAddTaskDialog',
      'fetchMediaList'
    ]),
    // 直接清空 localTask 所有字段
    resetForm() {
      // 重新赋值为初始值
      this.localTask = {
        taskType: 1,
        taskName: '',
        shortDramaAdName: '',
        bid: '',
        useHotMedia: true,
        selectedMediaIds: [],
        mobilePlatform: '',
        adFormat: [],
        materialType: null,
        imageType: null,
        productAttribute: [],
        layout: [],
        resolution: [],
        duration: [],
        durationFrom: null,
        durationTo: null,
        sortBy: null,
        timePeriod: null,
        start_date: '',
        end_date: '',
        pagesToFetch: 1,
        tags: []
      }
    },

    toggleMediaMode() {
      this.localTask.useHotMedia = !this.localTask.useHotMedia
    },

    // 视频时长区间校验
    handleDurationFromChange(val) {
      if (this.localTask.durationTo !== null && val !== null) {
        if (val > this.localTask.durationTo) {
          this.$message.warning('起始时长不能大于结束时长')
          this.localTask.durationFrom = null
        }
      }
    },
    handleDurationToChange(val) {
      if (this.localTask.durationFrom !== null && val !== null) {
        if (this.localTask.durationFrom > val) {
          this.$message.warning('结束时长不能小于起始时长')
          this.localTask.durationTo = null
        }
      }
    },
    // 处理单选按钮变化时的逻辑
    handleTimePeriodChange(value) {
      const today = new Date()
      let startDate = ''
      let endDate = ''

      if (value === 'today') {
        startDate = this.formatDate(today)
        endDate = this.formatDate(today)
      } else if (value === 'yesterday') {
        const yesterday = new Date(today)
        yesterday.setDate(today.getDate() - 1)
        startDate = this.formatDate(yesterday)
        endDate = this.formatDate(yesterday)
      } else if (value === '7days') {
        const sevenDaysAgo = new Date(today)
        sevenDaysAgo.setDate(today.getDate() - 6)
        startDate = this.formatDate(sevenDaysAgo)
        endDate = this.formatDate(today)
      } else if (value === '30days') {
        const thirtyDaysAgo = new Date(today)
        thirtyDaysAgo.setDate(today.getDate() - 29)
        startDate = this.formatDate(thirtyDaysAgo)
        endDate = this.formatDate(today)
      } else if (value === 'all') {
        // 全部日期
        startDate = ''
        endDate = ''
      }

      // 更新日期字段
      this.localTask.start_date = startDate
      this.localTask.end_date = endDate
      // 清空日期选择器
      this.dateRange = []
    },

    // 处理日期选择器变化时的逻辑
    handleDateRangeChange(value) {
      if (value && value.length === 2) {
        // 更新独立日期字段
        this.localTask.start_date = this.formatDate(new Date(value[0]))
        this.localTask.end_date = this.formatDate(new Date(value[1]))

        // 清空单选按钮的值
        this.localTask.timePeriod = null
      }
    },

    // 日期格式化工具方法 (yyyy-MM-dd)
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    // 取消操作，重置表单
    handleCancel() {
      this.resetForm()
      this.closeAddTaskDialog()
    },

    // 回车添加标签
    handleAddTag() {
      const input = this.tagInput.trim()
      // 如果输入不为空 且 不重复，则添加到 tags 数组中
      if (input && !this.localTask.tags.includes(input)) {
        this.localTask.tags.push(input)
      }
      // 清空输入框
      this.tagInput = ''
    },

    // 删除标签
    handleRemoveTag(index) {
      this.localTask.tags.splice(index, 1)
    },

    // 提交
    handleSubmit() {
      // 在这里可以把选中的字段映射到后端需要的格式
      // 比如后端需要 {task_type, name, keyword, media_ids...}:
      const requestBody = {
        // 任务类型
        task_type: this.localTask.taskType,
        // 任务名称
        name: this.localTask.taskName,
        // 精准搜索名称
        keyword: this.localTask.shortDramaAdName,

        // 媒体
        media_ids: this.localTask.selectedMediaIds,
        // bid
        bid: this.localTask.bid,
        // 设备
        mobile_type: this.localTask.mobilePlatform,
        // 广告形式
        ad_form: this.localTask.adFormat,
        // 素材类型
        material_type: this.localTask.materialType,
        // 图片类型
        image_type: Number(this.localTask.imageType),
        // 产品类型
        product_types: this.localTask.productAttribute,
        // 布局
        layout: this.localTask.layout,
        // 清晰度：
        definition_type: this.localTask.resolution,
        // 自定义tag
        tags: this.localTask.tags,

        // 视频时长
        // 这里是多选: ["0-3分钟","3-5分钟"], plus 自定义 X-Y
        duration_param: (() => {
          const arr = [...this.localTask.duration]
          const { durationFrom, durationTo } = this.localTask
          if (
            durationFrom !== null &&
            durationTo !== null &&
            durationFrom <= durationTo
          ) {
            arr.push(`${durationFrom}-${durationTo}分钟`)
          }
          return arr
        })(),

        sort_by: this.localTask.sortBy,

        start_date: this.localTask.start_date,
        end_date: this.localTask.end_date,

        // 页数
        page: this.localTask.pagesToFetch
      }
      // 你可以在这里发请求: this.$axios.post('/xxx', requestBody)...
      // 调用新增任务接口
      createAdxTask(requestBody)
        .then((response) => {
          console.log(response) // 打印返回的完整响应
          if (response && response.success === true) {
            // 判断 success 字段是否为 true
            this.$message.success('任务创建成功(*^▽^*)！')
            this.resetForm() // 重置表单
            this.closeAddTaskDialog() // 关闭弹窗
            this.refreshTaskList() // 刷新任务列表
          } else {
            this.$message.error(response.message)
          }
        })
        .catch((error) => {
          console.log(error.message)
        })
    }
  },
  watch: {
    mediaList: {
      handler(newVal) {
        this.hotMediaList = newVal.hot_media || []
        this.allMediaList = newVal.media_list || []
      },
      immediate: true
    }
  },
  mounted() {
    // 获取媒体列表
    this.fetchMediaList()
    // 初始化媒体列表
    this.hotMediaList = this.mediaList.hot_media || []
    this.allMediaList = this.mediaList.media_list || []
  }
}
</script>
<style scoped>
/* 整体弹窗样式 */
.large-dialog >>> .el-dialog {
  max-width: 1200px;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
.large-dialog >>> .el-dialog__header {
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  border-radius: 6px 6px 0 0;
}
.large-dialog >>> .el-dialog__title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

/* 各区域标题 */
.section-title {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
  color: #333;
}

.basic-info {
  display: flex;
  gap: 30px;
  align-items: center;
  margin-bottom: 20px;
}
.basic-info ::v-deep .el-form-item__label {
  width: auto;
  padding: 0 5px 0 0;
}

/* 媒体分类 */
.media-section {
  margin-bottom: 20px;
}
.media-category {
  margin-bottom: 16px;
}
.category-name {
  font-weight: 500;
  margin-bottom: 6px;
  color: #666;
}
.category-items {
  margin-left: 20px;
}

/* 更多筛选 */
.more-filter {
  margin-bottom: 20px;
}
.filter-group {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.filter-label {
  width: 90px;
  margin-right: 10px;
  color: #666;
  font-size: 14px;
}

/* mini-filter-line：小行布局 */
.mini-filter-line {
  margin-bottom: 10px;
}

/* 排序方式 & 高级筛选 */
.sort-section {
  margin-bottom: 20px;
}
.advance-filter {
  margin-bottom: 20px;
}

/* 底部按钮 */
.dialog-footer {
  text-align: right;
  margin-top: 20px;
}
.btn-cancel,
.btn-confirm {
  /* 去除动画、交互特效 */
  border-radius: 4px;
}
.inner-box {
  padding: 20px;
  margin: 10px 100px;
  background-color: #f9f9f9;
  border-radius: 5px;
}

/* 媒体切换按钮 */
.media-section .el-button {
  margin-bottom: 10px;
}

/* 全部媒体分类 */
.media-categories .media-category {
  margin-bottom: 16px;
}
</style>
